/** Replaces assignments for one environment site within the given document scope (sites-table semantics). */
export function applyConsentDocumentsChangeToAssignments(assignments, environmentSiteId, selectedConsentDocumentIds, consentDocumentIdsInScope) {
    const otherSitesAssignments = assignments.filter((a) => !(a.environmentSiteId === environmentSiteId && consentDocumentIdsInScope.includes(a.consentDocumentId)));
    const thisSitesSelectedAssignments = selectedConsentDocumentIds.map((consentDocumentId) => ({
        id: `${environmentSiteId}-${consentDocumentId}`,
        environmentSiteId,
        consentDocumentId,
    }));
    return [...otherSitesAssignments, ...thisSitesSelectedAssignments];
}
/** Replaces assignments for one consent document within the given environment sites (ICF table semantics). */
export function applyEnvironmentSitesChangeToAssignments(assignments, documentId, selectedEnvironmentSiteIds, environmentSites) {
    const siteIdsInEnv = new Set(environmentSites.map((s) => s.id));
    const otherDocumentsAssignments = assignments.filter((a) => !(a.consentDocumentId === documentId && siteIdsInEnv.has(a.environmentSiteId)));
    const thisDocumentsSelectedAssignments = selectedEnvironmentSiteIds.map((environmentSiteId) => ({
        id: `${environmentSiteId}-${documentId}`,
        environmentSiteId,
        consentDocumentId: documentId,
    }));
    return [...otherDocumentsAssignments, ...thisDocumentsSelectedAssignments];
}
